'use client';

import * as SeparatorPrimitive from '@radix-ui/react-separator';
import * as React from 'react';

import { cn } from '../../lib/cn';

export interface SeparatorProps extends React.ComponentPropsWithoutRef<
	typeof SeparatorPrimitive.Root
> {
	/** Direzione della linea divisoria. Default: `horizontal`. */
	orientation?: 'horizontal' | 'vertical';
	/** Se true (default), la linea è puramente visiva e viene nascosta agli screen reader. */
	decorative?: boolean;
}

/** Linea divisoria sottile per separare sezioni di contenuto. */
const Separator = React.forwardRef<
	React.ElementRef<typeof SeparatorPrimitive.Root>,
	SeparatorProps
>(({ className, orientation = 'horizontal', decorative = true, ...props }, ref) => (
	<SeparatorPrimitive.Root
		ref={ref}
		decorative={decorative}
		orientation={orientation}
		className={cn(
			'shrink-0 bg-border',
			orientation === 'horizontal' ? 'h-[1px] w-full' : 'h-full w-[1px]',
			className,
		)}
		{...props}
	/>
));
Separator.displayName = SeparatorPrimitive.Root.displayName;

export { Separator };
